<template>
  <div class="menuPanel">
    Menu 1 Content
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less">
.menuPanel {
    width: calc(100vw);
    height: 300px;
    position: fixed;
    left: 0px;
    bottom: 0px;
    background-color: white;
    z-index: 10;   
}
</style>